import {UserProfileProperty} from '@cas-hub/acabim-common-client';

export interface ContactParcel {
    readonly user_id?: string;
    readonly contact_type: number;
    readonly role_type: number;
    readonly first_name?: string;
    readonly last_name?: string;
    readonly legal_representative?: number;
    readonly legal_name?: string;
    readonly is_organisation: number;
    readonly member_of: number;
    readonly invitation: number;
    readonly invitation_email?: string;
    readonly preferred_contact?: number;
    readonly name?: string;
    readonly description?: string;
    readonly contacts?: ContactSimple[];

    readonly profile_properties: UserProfileProperty[];
    readonly organisation_properties: UserProfileProperty[];
}
export interface ContactSimple {
    readonly first_name: string;
    readonly last_name: string;
    readonly email: string;
    readonly invitation: number;
    readonly primary_contact?: number;
    readonly profile_properties: UserProfileProperty[];
}

export interface ContactMethods {
    id?: number;
    type: string;
    value: string;
    default: boolean;
}

export interface ContactNames {
    first_name: string;
    last_name: string;
    name: string;
    legal_name: string;
}

export enum ContactRoleType {
    'Administration',
    'Maintenance',
    'External'
}

export enum ContactProfilePropertyType {
    'text',
    'textarea',
    'number',
    'url',
    'date'
}

export interface ContactProfilePropertyModel {
    key: string;
    title: string;
    type: ContactProfilePropertyType;
    multiple?: boolean;
    labels?: {key: string, title: string}[];
    default_label?: string;
}

export interface ContactTable {
    id: number;
    user_id: string;
    first_name: string;
    last_name: string;
    contact_type: string;
    status: string;
    manager: number;
    email: string;
    phone: string;
}

export interface FormData {
    label: string;
    data: string;
}
